import { instance, instanceRoot } from "./apiRequest";

import {
    CONSUMER_LOGIN,
    SEND_VERIFY_CONSUMER_EMAIL_OTP,
    CONSUMER_VERIFY_EMAIL_OTP,
    RESEND_CONSUMER_VERIFY_EMAIL_OTP,
    UPDATE_CONSUMER_LOGIN_DATA,
    GET_CONSUMER_INFORMATION_BY_CONSUMER_ID,
    FORGOT_PASSWORD_SEND_EMAIL_OTP,
    FORGOT_USER_PASSWORD,
    CHANGE_CONSUMER_PASSWORD,
    GET_CONSUMER_APPLICANTS_BY_EMAIL,
    GET_APPLICATION_REVIEW_COMMENT_BY_APPLICATION_ID,
    CHANGE_USER_PASSWORD,
    UPLOAD_PDF_OR_DOC,
    UPDATE_CONSUMER_DATA,
    Submit_Applicant_Details_Api,
    Submit_Upload_Documents_Api,
    SEND_VERIFY_EMAIL_OTP,
    CONFIRM_EMAIL_OTP, UPDATE_APPLICANT_DATA,
    GET_ALL_DROPDOWN_DATA_BY_NAME,
    GET_APPLICANT_INFORMATION_BY_APPLICATION_ID,
    ADD_OR_UPDATE_CASH_SHORT_TERM_INVESTMENTS,
    GET_CASH_SHORT_TERM_INVESTMENTS_BY_APPLICATIONID,
    DELETE_CASH_SHORT_TERM_INVESTMENTS_BY_CASH_ID,
    GET_APPLICATION_LIST_BY_EMAIL,
    ADD_OR_UPDATE_STOCK_BOND_GOV_SECURITY,
    GET_STOCK_BOND_GOV_SECURITY_BY_APPLICATION_ID,
    DELETE_STOCK_BOND_GOV_SECURITY_BY_STOCK_ID,
    GET_ACCOUNT_NOTE_RECEIVABLE_BY_APPLICATION_ID,
    ADD_O_RUPDATE_ACCOUNT_NOTE_RECEIVABLE,
    DELETE_ACCOUNT_NOTE_RECEIVABLE_BY_ACCOUNT_ID,
    ADD_OR_UPDATE_CASH_VALUE_LIFE_INSURANCE,
    DELETE_CASH_VALUE_LIFE_INSURANCE_BY_CASHVALUE_ID,
    GET_CASH_VALUE_LIFE_INSURANCE_BY_APPLICATION_ID,
    UPDATE_APPLICANT_FINANCIAL_DATA,
    GET_FINANCIAL_STATEMENT_DATA,
    UPLOAD_PHOTO_IMAGE,
    UPLOAD_PDF_OR_DOC_FILE,
    ADD_OR_UPDATE_INCOME_SOURCE,
    GET_INCOME_SOURCE_BY_APPLICATION_ID,
    ADD_OR_UPDATE_EXPENSES,
    GET_EXPENSES_BY_APPLICATION_ID,
    ADD_OR_UPDATE_OWN_PERSONAL_RESIDENCE,
    GET_OWN_PERSONAL_RESIDENCE_BY_APPLICATION_ID,
    DELETE_OWN_PERSONAL_RESIDENCE_BY_OWN_ID,
    ADD_OR_UPDATE_VESTED_INTREST_PENSION,
    GET_VESTED_INTREST_PENSION_BY_APPLICATION_ID,
    DELETE_VESTED_INTREST_PENSION_BY_OWN_ID,
    ADD_OR_UPDATE_UNLISTED_STOCKS,
    GET_UNLISTED_STOCKS_BY_APPLICATION_ID,
    GET_APPLICANT_ASSESMENT_INFO_BY_APPLICATION_ID,
    DELETE_UNLISTED_STOCKS_BY_UNLISTED_STOCK_ID,
    ADD_OR_UPDATE_INVESTMENT,
    GET_INVESTMENT_BY_APPLICATION_ID,
    DELETE_INVESTMENT_BY_INVESTMENT_ID,
    ADD_OR_UPDATE_GENERAL_AND_LIMITED_PARTENERSHIP,
    GET_GENERAL_AND_LIMITED_PARTENERSHIP_BY_APPLICATION_ID,
    DELETE_GENERAL_AND_LIMITED_PARTENERSHIP_BY_INVESTMENT_ID,
    CONFIRM_EMAIL_OTP_FOR_USER_ACCOUNT,
    ADD_OR_UPDATE_NOTES_PAYABLE_BANK_SECURED,
    GET_NOTES_PAYABLE_BANK_SECURED_BY_APPLICATION_ID,
    DELETE_NOTES_PAYABLE_BANK_SECURED_BY_NOTES_ID,
    ADD_OR_UPDATENOTES_PAYABLE_BANK_UNSECURED,
    GET_NOTES_PAYABLE_BANK_UNSECURED_BY_APPLICATION_ID,
    DELETE_NOTES_PAYABLE_BANK_UNSECURED_BY_NOTES_ID,
    ADD_OR_UPDATE_NOTES_PAYABLE_OTHER,
    GET_NOTES_PAYABLE_OTHER_BY_APPLICATION_ID,
    DELETE_NOTES_PAYABLE_OTHER_BY_NOTES_ID,
    ADD_OR_UPDATE_ACCOUNTS_PAYABLE,
    GET_ACCOUNTS_PAYABLE_BY_APPLICATION_ID,
    DELETE_ACCOUNTS_PAYABLE_BY_ACCOUNT_ID,
    ADD_OR_UPDATE_CREDIT_CARD_BALANCE,
    GET_CREDIT_CARD_BALANCE_BY_APPLICATION_ID,
    DELETE_CREDIT_CARD_BALANCE_BY_CREDIT_ID,
    ADD_OR_UPDATE_MORTGAGE_DUE_WITHIN,
    GET_MORTGAGE_DUE_WITHIN_BY_APPLICATION_ID,
    DELETE_DOCUMENT_DATA_BY_APPLICATION_ID,
    DELETE_APPLICATION_BY_APPLICATION_ID,
    SUBMIT_APPLICATION_BY_APPLICATION_ID,
    DELETE_MORTGAGE_DUE_WITHIN_BY_ID,
    ADD_OR_UPDATE_MORTGAGE_DUE_BEYOND,
    GET_MORTGAGE_DUE_BEYOND_BY_APPLICATION_ID,
    DELETE_MORTGAGE_DUE_BEYOND_BY_ID,
    GET_ALL_QUESTIONS,
    ADD_OR_UPDATE_QUESTIONS,
    GET_QUESTIONS_BY_APPLICATION_ID,
    GET_SPONSER_DATA_BY_APPLICANT_EMAIL,
    GET_APPLICATION_STATUS_BY_APPLICATION_ID,
    GET_APPLICATION_STATUS_BY_APPLICATION_ID_AND_DOB,
    USER_LOGIN,
    GET_BANK_ADMIN_LIST_BY_EMAIL,
    GET_APPLICANTS_BY_EMAIL_AND_BANK_ADMIN,
    GET_FIRM_ADMIN_DASHBOARD_BY_EMAIL_AND_BANK_ADMIN_ID,
    GET_APPLICATION_REVIEW_COMMENT_BY_APPLICATION_ID_AND_SECTION,
    DELETE_DOCUMENT_BY_DOCUMENT_ID,
    GET_CONSUMER_REPORT_BY_CONSUMER_ID,
    CREATEPREPOPULATEDPDFFORPFS,
    ADDORUPDATEEQUITYINTERESTINBUSINESS,
    GETEQUITYINTERESTINBUSINESSBYAPPLICATIONID,
    DELETEEQUITYINTERESTINBUSINESSBYINCOMETYPEID
} from "../constants/constants";

let _consumerService = {
    async consumerLogin(obj) {
        return await instance.post(CONSUMER_LOGIN, obj);
    },
    async sendVerifyConsumerEmailOTP(obj) {
        return await instance.post(SEND_VERIFY_CONSUMER_EMAIL_OTP, obj);
    },
    async consumerConfirmEmailOTP(obj) {
        return await instance.post(CONSUMER_VERIFY_EMAIL_OTP, obj);
    },
    async resendConsumerVerifyEmailOTP(obj) {
        return await instance.post(RESEND_CONSUMER_VERIFY_EMAIL_OTP, obj);
    },
    async updateConsumerData(reqObj) {
        return await instance.post(UPDATE_CONSUMER_LOGIN_DATA, reqObj);
    },
    async getConsumerInformationByConsumerId(consumerId) {
        let url = GET_CONSUMER_INFORMATION_BY_CONSUMER_ID + "?applicationId=" + consumerId;
        return await instance.get(url);
    },
    async forgotPasswordSendEmailOTP(obj) {
        return await instance.post(FORGOT_PASSWORD_SEND_EMAIL_OTP, obj);
    },
    async forgotUserLoginPassword(reqObj) {
        return await instance.post(FORGOT_USER_PASSWORD, reqObj);
    },
    async changeConsumerPassword(reqObj) {
        return await instance.post(CHANGE_CONSUMER_PASSWORD, reqObj);
    },
    async getConsumerApplicantsByEmail(emailId) {
        let url = GET_CONSUMER_APPLICANTS_BY_EMAIL + "?email=" + emailId;
        return await instance.get(url);
    },
    async getReviewCommentByApplicationId(applicationId) {
        let url = GET_APPLICATION_REVIEW_COMMENT_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async changeConsumerLoginPassword(reqObj) {
        return await instance.post(CHANGE_USER_PASSWORD, reqObj);
    },
    async UploadPdfOrDocFile(formData, applicationId, uploadFieldsName) {
        return await instanceRoot.post(`${UPLOAD_PDF_OR_DOC}?UploadFieldsName=${uploadFieldsName}&applicationId=${applicationId}`, formData);
    },
    async submitConsumerData(reqObj) {
        return await instance.post(UPDATE_CONSUMER_DATA, reqObj);
    },
    async getApplicantAssesmentInfoByApplicationId(applicationId) {
        let url = GET_APPLICANT_ASSESMENT_INFO_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async userLogin(obj) {
        return await instance.post(USER_LOGIN, obj);
    },
    async verifyEmail(obj) {
        return await instance.post(SEND_VERIFY_EMAIL_OTP, obj);
    },
    async verifyOtp(obj) {
        return await instance.post(CONFIRM_EMAIL_OTP, obj);
    },
    async forgotPasswordSendEmailOTP(obj) {
        return await instance.post(FORGOT_PASSWORD_SEND_EMAIL_OTP, obj);
    },
    async forgotUserLoginPassword(reqObj) {
        return await instance.post(FORGOT_USER_PASSWORD, reqObj);
    },
    async updateUserPassword(reqObj) {
        return await instance.post(UPDATE_APPLICANT_DATA, reqObj);
    },
    async verifyOtpForUserAccount(obj) {
        return await instance.post(CONFIRM_EMAIL_OTP_FOR_USER_ACCOUNT, obj);
    },
    async getAllDropdownDataByName(dropdownDataByName) {
        let url = GET_ALL_DROPDOWN_DATA_BY_NAME + "?parameter=" + dropdownDataByName;
        return await instance.get(url);
    },
    async getApplicantInformationByApplicationId(applicationId) {
        let url = GET_APPLICANT_INFORMATION_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async submitApplicantData(reqObj) {
        return await instance.post(UPDATE_APPLICANT_DATA, reqObj);
    },
    async AddOrUpdateIncomeSource(reqObj) {
        return await instance.post(ADD_OR_UPDATE_INCOME_SOURCE, reqObj);
    },
    async getIncomeSourceByApplicationID(applicationId) {
        let url = GET_INCOME_SOURCE_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async addOrUpdateExpenses(reqObj) {
        return await instance.post(ADD_OR_UPDATE_EXPENSES, reqObj);
    },
    async getExpensesByApplicationID(applicationId) {
        let url = GET_EXPENSES_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async addUpdateCashShortTermInvestments(reqObj) {
        return await instance.post(ADD_OR_UPDATE_CASH_SHORT_TERM_INVESTMENTS, reqObj);
    },
    async getCashShortTermInvestmentsByApplicationID(applicationId) {
        let url = GET_CASH_SHORT_TERM_INVESTMENTS_BY_APPLICATIONID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async deleteCashShortTermInvestmentsByCashID(Id) {
        let url = DELETE_CASH_SHORT_TERM_INVESTMENTS_BY_CASH_ID + "?Id=" + Id;
        return await instance.post(url);
    },
    async addOrUpdateStockBondGovSecurity(reqObj) {
        return await instance.post(ADD_OR_UPDATE_STOCK_BOND_GOV_SECURITY, reqObj);
    },
    async getStockBondGovSecurityByApplicationID(applicationId) {
        let url = GET_STOCK_BOND_GOV_SECURITY_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async deleteStockBondGovSecurityByStockID(Id) {
        let url = DELETE_STOCK_BOND_GOV_SECURITY_BY_STOCK_ID + "?Id=" + Id;
        return await instance.post(url);
    },
    async getAccountNoteReceivableByApplicationID(applicationId) {
        let url = GET_ACCOUNT_NOTE_RECEIVABLE_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async AddOrUpdateAccountNoteReceivable(reqObj) {
        return await instance.post(ADD_O_RUPDATE_ACCOUNT_NOTE_RECEIVABLE, reqObj);
    },
    async deleteAccountNoteReceivableByAccountID(Id) {
        let url = DELETE_ACCOUNT_NOTE_RECEIVABLE_BY_ACCOUNT_ID + "?Id=" + Id;
        return await instance.post(url);
    },
    async addOrUpdateCashValueLifeInsurance(reqObj) {
        return await instance.post(ADD_OR_UPDATE_CASH_VALUE_LIFE_INSURANCE, reqObj);
    },
    async deleteCashValueLifeInsuranceByCashValueID(Id) {
        let url = DELETE_CASH_VALUE_LIFE_INSURANCE_BY_CASHVALUE_ID + "?Id=" + Id;
        return await instance.post(url);
    },
    async getCashValueLifeInsuranceByApplicationID(applicationId) {
        let url = GET_CASH_VALUE_LIFE_INSURANCE_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async updateApplicantFinancialData(reqObj) {
        return await instance.post(UPDATE_APPLICANT_FINANCIAL_DATA, reqObj);
    },
    async getFinancialStatementData(applicationId, screenName) {
        let url = GET_FINANCIAL_STATEMENT_DATA + "?applicationId=" + applicationId + "&screenName=" + screenName;
        return await instance.get(url);
    },
    async addOrUpdateOwnPersonalResidence(reqObj) {
        return await instance.post(ADD_OR_UPDATE_OWN_PERSONAL_RESIDENCE, reqObj);
    },
    async getOwnPersonalResidenceByApplicationID(applicationId) {
        let url = GET_OWN_PERSONAL_RESIDENCE_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async deleteOwnPersonalResidenceByOwnID(Id) {
        let url = DELETE_OWN_PERSONAL_RESIDENCE_BY_OWN_ID + "?Id=" + Id;
        return await instance.post(url);
    },
    async saveProofOfTrustData(reqObj) {
        return await instance.post(Submit_Applicant_Details_Api, reqObj, {
            headers: { "Content-Type": "application/json" }
        });
    },
    async saveUploadDocumentData(reqObj) {
        return await instance.post(Submit_Upload_Documents_Api, reqObj);
    },
    async getApplicationListByEmail(emailId) {
        let url = GET_APPLICATION_LIST_BY_EMAIL + "?email=" + emailId;
        return await instance.get(url);
    },
    async UploadPhotoImage(formData, applicationId, uploadPhotoName) {

        return await instanceRoot.post(`${UPLOAD_PHOTO_IMAGE}?uploadPhotoName=${uploadPhotoName}&applicationId=${applicationId}`, formData);
    },
    async UploadPdfOrDocFile(formData, applicationId, uploadFieldsName) {
        return await instanceRoot.post(`${UPLOAD_PDF_OR_DOC_FILE}?UploadFieldsName=${uploadFieldsName}&applicationId=${applicationId}`, formData);
    },
    async UploadPdfOrDocFileRowId(formData, applicationId, uploadFieldsName, rowId) {
        return await instanceRoot.post(`${UPLOAD_PDF_OR_DOC_FILE}?UploadFieldsName=${uploadFieldsName}&applicationId=${applicationId}&rowId=${rowId}`, formData);
    },

    async addOrUpdateVestedIntrestPension(reqObj) {
        return await instance.post(ADD_OR_UPDATE_VESTED_INTREST_PENSION, reqObj);
    },
    async getVestedIntrestPensionByApplicationID(applicationId) {
        let url = GET_VESTED_INTREST_PENSION_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async deleteVestedIntrestPensionByOwnID(Id) {
        let url = DELETE_VESTED_INTREST_PENSION_BY_OWN_ID + "?Id=" + Id;
        return await instance.post(url);
    },
    async addOrUpdateUnListedStocks(reqObj) {
        return await instance.post(ADD_OR_UPDATE_UNLISTED_STOCKS, reqObj);
    },
    async getUnListedStocksByApplicationID(applicationId) {
        let url = GET_UNLISTED_STOCKS_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async addOrUpdateEquityInterestInBusiness(reqObj) {
        return await instance.post(ADDORUPDATEEQUITYINTERESTINBUSINESS, reqObj);
    },
    async getEquityInterestInBusinessByApplicationID(applicationId) {
        let url = GETEQUITYINTERESTINBUSINESSBYAPPLICATIONID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async getApplicantAssesmentInfoByApplicationId(applicationId) {
        let url = GET_APPLICANT_ASSESMENT_INFO_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async getReviewCommentByApplicationId(applicationId) {
        let url = GET_APPLICATION_REVIEW_COMMENT_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async deleteUnListedStocksByunlistedStockID(Id) {
        let url = DELETE_UNLISTED_STOCKS_BY_UNLISTED_STOCK_ID + "?Id=" + Id;
        return await instance.post(url);
    },
    async deleteEquityInterestInBusinessByIncomeTypeID(Id) {
        let url = DELETEEQUITYINTERESTINBUSINESSBYINCOMETYPEID + "?Id=" + Id;
        return await instance.post(url);
    },
    async addOrUpdateInvestment(reqObj) {
        return await instance.post(ADD_OR_UPDATE_INVESTMENT, reqObj);
    },
    async getInvestmentByApplicationID(applicationId) {
        let url = GET_INVESTMENT_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async deleteInvestmentByInvestmentID(Id) {
        let url = DELETE_INVESTMENT_BY_INVESTMENT_ID + "?Id=" + Id;
        return await instance.post(url);
    },
    async addOrUpdateGeneralAndLimitedPartenership(reqObj) {
        return await instance.post(ADD_OR_UPDATE_GENERAL_AND_LIMITED_PARTENERSHIP, reqObj);
    },
    async getGeneralAndLimitedPartenershipByApplicationID(applicationId) {
        let url = GET_GENERAL_AND_LIMITED_PARTENERSHIP_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async deleteGeneralAndLimitedPartenershipByInvestmentID(Id) {
        let url = DELETE_GENERAL_AND_LIMITED_PARTENERSHIP_BY_INVESTMENT_ID + "?Id=" + Id;
        return await instance.post(url);
    },
    async addOrUpdateNotesPayableBankSecured(reqObj) {
        return await instance.post(ADD_OR_UPDATE_NOTES_PAYABLE_BANK_SECURED, reqObj);
    },
    async getNotesPayableBankSecuredByApplicationID(applicationId) {
        let url = GET_NOTES_PAYABLE_BANK_SECURED_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async deleteNotesPayableBankSecuredByNotesID(Id) {
        let url = DELETE_NOTES_PAYABLE_BANK_SECURED_BY_NOTES_ID + "?Id=" + Id;
        return await instance.post(url);
    },
    async addOrUpdateNotesPayableBankUnSecured(reqObj) {
        return await instance.post(ADD_OR_UPDATENOTES_PAYABLE_BANK_UNSECURED, reqObj);
    },
    async getNotesPayableBankUnSecuredByApplicationID(applicationId) {
        let url = GET_NOTES_PAYABLE_BANK_UNSECURED_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async deleteNotesPayableBankUnSecuredByNotesID(Id) {
        let url = DELETE_NOTES_PAYABLE_BANK_UNSECURED_BY_NOTES_ID + "?Id=" + Id;
        return await instance.post(url);
    },
    async addOrUpdateNotesPayableOther(reqObj) {
        return await instance.post(ADD_OR_UPDATE_NOTES_PAYABLE_OTHER, reqObj);
    },
    async getNotesPayableOtherByApplicationID(applicationId) {
        let url = GET_NOTES_PAYABLE_OTHER_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async deleteNotesPayableOtherByNotesID(Id) {
        let url = DELETE_NOTES_PAYABLE_OTHER_BY_NOTES_ID + "?Id=" + Id;
        return await instance.post(url);
    },
    async addOrUpdateAccountsPayable(reqObj) {
        return await instance.post(ADD_OR_UPDATE_ACCOUNTS_PAYABLE, reqObj);
    },
    async getAccountsPayableByApplicationID(applicationId) {
        let url = GET_ACCOUNTS_PAYABLE_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async deleteAccountsPayableByAccountID(Id) {
        let url = DELETE_ACCOUNTS_PAYABLE_BY_ACCOUNT_ID + "?Id=" + Id;
        return await instance.post(url);
    },
    async addOrUpdateCreditCardBalance(reqObj) {
        return await instance.post(ADD_OR_UPDATE_CREDIT_CARD_BALANCE, reqObj);
    },
    async getCreditCardBalanceByApplicationID(applicationId) {
        let url = GET_CREDIT_CARD_BALANCE_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async deleteCreditCardBalanceByCreditID(Id) {
        let url = DELETE_CREDIT_CARD_BALANCE_BY_CREDIT_ID + "?Id=" + Id;
        return await instance.post(url);
    },
    async addOrUpdateMortgageDueWithin(reqObj) {
        return await instance.post(ADD_OR_UPDATE_MORTGAGE_DUE_WITHIN, reqObj);
    },
    async getMortgageDueWithinByApplicationID(applicationId) {
        let url = GET_MORTGAGE_DUE_WITHIN_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async deleteDocumentDataByApplicationId(applicationId, docName) {
        let url = DELETE_DOCUMENT_DATA_BY_APPLICATION_ID + "?applicationId=" + applicationId + "&docName=" + docName;
        return await instance.get(url);
    },
    async deleteApplicationByAppId(applicationId) {
        let url = DELETE_APPLICATION_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async submitApplicationByAppId(obj) {
        return await instance.post(SUBMIT_APPLICATION_BY_APPLICATION_ID, obj);
    },
    async deleteMortgageDueWithinByID(Id) {
        let url = DELETE_MORTGAGE_DUE_WITHIN_BY_ID + "?Id=" + Id;
        return await instance.post(url);
    },
    async addOrUpdateMortgageDueBeyond(reqObj) {
        return await instance.post(ADD_OR_UPDATE_MORTGAGE_DUE_BEYOND, reqObj);
    },
    async getMortgageDueBeyondByApplicationID(applicationId) {
        let url = GET_MORTGAGE_DUE_BEYOND_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async deleteMortgageDueBeyondByID(Id) {
        let url = DELETE_MORTGAGE_DUE_BEYOND_BY_ID + "?Id=" + Id;
        return await instance.post(url);
    },
    async getAllQuestions() {
        let url = GET_ALL_QUESTIONS;
        return await instance.get(url);
    },
    async addOrUpdateQuestions(reqObj) {
        return await instance.post(ADD_OR_UPDATE_QUESTIONS, reqObj);
    },
    async getQuestionsByApplicationID(applicationId) {
        let url = GET_QUESTIONS_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async getSponserDataByApplicantEmail(emailId, sponserId) {
        let url = GET_SPONSER_DATA_BY_APPLICANT_EMAIL + "?applicantEmail=" + emailId + "&sponserId=" + sponserId;
        return await instance.get(url);
    },
    async getApplicationStatusByApplicationId(applicationId) {
        let url = GET_APPLICATION_STATUS_BY_APPLICATION_ID + "?applicationId=" + applicationId;
        return await instance.get(url);
    },
    async getApplicationStatusByApplicationIdDOB(applicationId, dob) {
        let url = GET_APPLICATION_STATUS_BY_APPLICATION_ID_AND_DOB + "?applicantionId=" + applicationId + "&applicantDOB=" + dob;
        return await instance.get(url);
    },
    async getBankAdminListByEmail(emailId, IsFirmAdmin) {
        let url = GET_BANK_ADMIN_LIST_BY_EMAIL + "?email=" + emailId + "&IsFirmAdmin=" + IsFirmAdmin;
        return await instance.get(url);
    },
    async getApplicantsByEmailAndBankAdmin(emailId, id) {
        let url = GET_APPLICANTS_BY_EMAIL_AND_BANK_ADMIN + "?email=" + emailId + "&bankAdminId=" + id;
        return await instance.get(url);
    },

    async getFirmAdminDashboardByEmailandBankAdminId(email, BankAdminId) {
        let url = GET_FIRM_ADMIN_DASHBOARD_BY_EMAIL_AND_BANK_ADMIN_ID + "?email=" + email + "&BankAdminId=" + BankAdminId;
        return await instance.get(url);
    },
    async getApplicationReviewCommentByApplicationIdAndSection(applicationId, section) {
        let url = GET_APPLICATION_REVIEW_COMMENT_BY_APPLICATION_ID_AND_SECTION + "?applicationId=" + applicationId + "&section=" + section;
        return await instance.get(url);
    },
    async deleteDocumentByDocumentId(ownId, section) {
        let url = DELETE_DOCUMENT_BY_DOCUMENT_ID + "?ownId=" + ownId + "&section=" + section;
        return await instance.get(url);
    },
    async getConsumerReportByConsumerId(consumerId) {
        let url = GET_CONSUMER_REPORT_BY_CONSUMER_ID + "?applicationId=" + consumerId;
        return await instance.get(url);
    },
    async CreatePrepopulatedPDFforPFSNew(consumerId) {
        let url = CREATEPREPOPULATEDPDFFORPFS + "?applicationId=" + consumerId;
        return await instance.get(url);
    },
}

export default _consumerService;